import { render, staticRenderFns } from "./RecruitmentJobCreate.vue?vue&type=template&id=061b7922"
import script from "./RecruitmentJobCreate.vue?vue&type=script&lang=js"
export * from "./RecruitmentJobCreate.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentJobCreate.vue?vue&type=style&index=0&id=061b7922&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports